<template>
  <tips-modal :steps="steps"/>
</template>

<script setup>
import AdmissionChancesTip from "@/components/tips/AdmissionChancesTip.vue"
import JobScoreTip from "@/components/tips/JobScoreTip.vue"
import TipsModal from "@/components/modals/TipsModal.vue"
import WelcomeTip from "@/components/tips/WelcomeTip.vue"

const steps = [
  WelcomeTip,
  JobScoreTip,
  AdmissionChancesTip,
]
</script>
